import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';

var genProListStyle = function genProListStyle(token) {
  var _hover, _showActionHover, _noSplit, _$concat5, _row, _token$componentCls;

  return _defineProperty({}, token.componentCls, (_token$componentCls = {
    backgroundColor: 'transparent'
  }, _defineProperty(_token$componentCls, "".concat(token.proComponentsCls, "-table-alert"), {
    marginBlockEnd: '16px'
  }), _defineProperty(_token$componentCls, '&-row', (_row = {
    borderBlockEnd: "1px solid ".concat(token.colorSplit)
  }, _defineProperty(_row, "".concat(token.antCls, "-list-item-meta-title"), {
    borderBlockEnd: 'none',
    margin: 0
  }), _defineProperty(_row, '&:last-child', _defineProperty({
    borderBlockEnd: 'none'
  }, "".concat(token.antCls, "-list-item"), {
    borderBlockEnd: 'none'
  })), _defineProperty(_row, '&:hover', (_hover = {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    transition: 'background-color 0.3s'
  }, _defineProperty(_hover, "".concat(token.antCls, "-list-item-action"), {
    display: 'block'
  }), _defineProperty(_hover, "".concat(token.antCls, "-list-item-extra"), {
    display: 'flex'
  }), _defineProperty(_hover, "".concat(token.componentCls, "-row-extra"), {
    display: 'block'
  }), _defineProperty(_hover, "".concat(token.componentCls, "-row-subheader-actions"), {
    display: 'block'
  }), _hover)), _defineProperty(_row, '&-card', _defineProperty({
    marginBlock: 8,
    marginInline: 0,
    paddingBlock: 0,
    paddingInline: 8,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }, "".concat(token.antCls, "-list-item-meta-title"), {
    flexShrink: 9,
    marginBlock: 0,
    marginInline: 0,
    lineHeight: '22px'
  })), _defineProperty(_row, "&".concat(token.componentCls, "-row-editable"), _defineProperty({}, "".concat(token.componentCls, "-list-item"), {
    '&-meta': {
      '&-avatar,&-description,&-title': {
        paddingBlock: 6,
        paddingInline: 0
      }
    },
    '&-action': {
      display: 'block'
    }
  })), _defineProperty(_row, "&".concat(token.componentCls, "-row-selected"), {
    backgroundColor: token.colorPrimaryBgHover,
    '&:hover': {
      backgroundColor: token.colorPrimaryBgHover
    }
  }), _defineProperty(_row, "&".concat(token.componentCls, "-row-type-new"), {
    animation: 'techUiListActive 3s'
  }), _defineProperty(_row, "&".concat(token.componentCls, "-row-type-inline"), _defineProperty({}, "".concat(token.componentCls, "-row-title"), {
    fontWeight: 'normal'
  })), _defineProperty(_row, "&".concat(token.componentCls, "-row-type-top"), {
    backgroundImage: "url('https://gw.alipayobjects.com/zos/antfincdn/DehQfMbOJb/icon.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left top',
    backgroundSize: '12px 12px'
  }), _defineProperty(_row, '&-show-action-hover', (_showActionHover = {}, _defineProperty(_showActionHover, "".concat(token.antCls, "-list-item-action,\n            ").concat(token.proComponentsCls, "-card-extra,\n            ").concat(token.proComponentsCls, "-card-actions"), {
    display: 'none'
  }), _defineProperty(_showActionHover, '&:hover', _defineProperty({}, "".concat(token.proComponentsCls, "-card-extra,").concat(token.proComponentsCls, "-card-actions"), {
    display: 'flex'
  })), _showActionHover)), _defineProperty(_row, '&-show-extra-hover', _defineProperty({}, "".concat(token.antCls, "-list-item-extra"), {
    display: 'none'
  })), _defineProperty(_row, '&-extra', {
    display: 'none'
  }), _defineProperty(_row, '&-subheader', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '44px',
    paddingInline: 24,
    paddingBlock: 0,
    color: token.colorTextSecondary,
    lineHeight: '44px',
    background: 'rgba(0, 0, 0, 0.02)',
    '&-actions': {
      display: 'none'
    },
    '&-actions *': {
      marginInlineEnd: 8,
      '&:last-child': {
        marginInlineEnd: 0
      }
    }
  }), _defineProperty(_row, '&-expand-icon', {
    marginInlineEnd: 8,
    color: token.colorTextSecondary,
    '> .anticon > svg': {
      transition: '0.3s'
    }
  }), _defineProperty(_row, '&-expanded', {
    ' > .anticon > svg': {
      transform: 'rotate(90deg)'
    }
  }), _defineProperty(_row, '&-title', {
    marginInlineEnd: '16px',
    wordBreak: 'break-all',
    cursor: 'pointer',
    '&:hover': {
      color: token.colorPrimary
    }
  }), _defineProperty(_row, '&-content', {
    position: 'relative',
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    marginBlock: 0,
    marginInline: 32
  }), _defineProperty(_row, '&-subTitle', {
    color: 'rgba(0, 0, 0, 0.45)'
  }), _defineProperty(_row, '&-description', {
    marginBlockStart: '4px',
    wordBreak: 'break-all'
  }), _defineProperty(_row, '&-avatar', {
    display: 'flex'
  }), _defineProperty(_row, '&-header', {
    display: 'flex',
    flex: '1',
    justifyContent: 'flex-start'
  }), _defineProperty(_row, '&-header-title', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  }), _defineProperty(_row, '&-header-option', {
    display: 'flex'
  }), _defineProperty(_row, '&-checkbox', {
    width: '16px',
    marginInlineEnd: '12px'
  }), _defineProperty(_row, '&-no-split', (_noSplit = {}, _defineProperty(_noSplit, "".concat(token.componentCls, "-row"), {
    borderBlockEnd: 'none'
  }), _defineProperty(_noSplit, "".concat(token.antCls, "-list ").concat(token.antCls, "-list-item"), {
    borderBlockEnd: 'none'
  }), _noSplit)), _defineProperty(_row, '&-bordered', _defineProperty({}, "".concat(token.componentCls, "-toolbar"), {
    borderBlockEnd: "1px solid ".concat(token.colorSplit)
  })), _defineProperty(_row, "".concat(token.antCls, "-list-vertical"), (_$concat5 = {}, _defineProperty(_$concat5, "".concat(token.componentCls, "-row"), {
    borderBlockEnd: '12px 18px 12px 24px'
  }), _defineProperty(_$concat5, '&-header-title', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  }), _defineProperty(_$concat5, '&-content', {
    marginBlock: 0,
    marginInline: 0
  }), _defineProperty(_$concat5, '&-subTitle', {
    marginBlockStart: 8
  }), _defineProperty(_$concat5, "".concat(token.antCls, "-list-item-extra"), _defineProperty({
    display: 'flex',
    alignItems: 'center',
    marginInlineStart: '32px'
  }, "".concat(token.componentCls, "-row-description"), {
    marginBlockStart: 16
  })), _defineProperty(_$concat5, "".concat(token.antCls, "-list-bordered ").concat(token.antCls, "-list-item"), {
    paddingInline: 0
  }), _defineProperty(_$concat5, "".concat(token.componentCls, "-row-show-extra-hover"), _defineProperty({}, "".concat(token.antCls, "-list-item-extra "), {
    display: 'none'
  })), _$concat5)), _defineProperty(_row, "".concat(token.antCls, "-list-pagination"), {
    marginBlockEnd: token.marginLG
  }), _defineProperty(_row, "".concat(token.antCls, "-list-list"), {
    '&-item': {
      cursor: 'pointer',
      paddingBlock: 12,
      paddingInline: 12
    }
  }), _defineProperty(_row, "".concat(token.antCls, "-list-vertical .").concat(token.proComponentsCls, "-list-row ").concat(token.antCls, "-list"), _defineProperty({
    '&-header': {
      paddingBlock: 0,
      paddingInline: 0,
      borderBlockEnd: 'none'
    }
  }, "".concat(token.antCls, "-list-item"), {
    width: '100%',
    paddingBlock: 12,
    paddingInlineStart: 24,
    paddingInlineEnd: 18,
    '&-meta-avatar': {
      display: 'flex',
      alignItems: 'center',
      marginInlineEnd: 8
    },
    '&-action-split': {
      display: 'none'
    },
    '&-meta-title': {
      marginBlock: 0,
      marginInline: 0
    }
  })), _defineProperty(_row, '@keyframes techUiListActive', {
    '0%': {
      backgroundColor: 'unset'
    },
    '30%': {
      background: '#fefbe6'
    },
    '100%': {
      backgroundColor: 'unset'
    }
  }), _row)), _token$componentCls));
};

export function useStyle(prefixCls) {
  return useAntdStyle('ProList', function (token) {
    var proListToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    });

    return [genProListStyle(proListToken)];
  });
}